import React, { useEffect, useState } from "react";
import YouTube from "react-youtube";
import styles from "./MediaReleasesAds.module.scss";
import { Layout, Banner, Carousel, Loader, ViewPreview, ArrowButton } from "../../../components";
import { getTvAds } from "../../../api/news.api";
import useXBreakpoint from "../../../hooks/useXBreakpoint";
import useFetchB2B from "../../../helpers/useFetchB2B";

const youtubeFrameOpts = {
  height: "700px",
  width: "1900px",
  playerVars: {
    controls: 2,
  },
};

const MediaReleasesAds = () => {
  const { currentPage } = useFetchB2B({
    url: "b2b/media-videos/slug",
    bySlug: true,
  });

  const [tvAds, setTvAds] = useState([]);
  const [activeVideo, setActiveVideo] = useState("");
  const [playlist, setPlaylist] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMobile = useXBreakpoint(768);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await getTvAds();
        setLoading(false);
        if (response.message === "success") {
          setTvAds(response.data.tvads.data);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  useEffect(() => {
    if (tvAds && tvAds.length) {
      setActiveVideo(tvAds[0]);
    }
  }, [tvAds]);

  const onVideoReady = event => {
    event.target.pauseVideo();
  };

  const setActiveVideoId = video => () => {
    if (playlist) {
      playlist.forEach(player => {
        player.pauseVideo();
      });
    }

    setActiveVideo(video);
  };

  const leftButtonRef = React.createRef();
  const rightButtonRef = React.createRef();

  const previews = tvAds.map(({ url, name }) => ({
    name,
    url: `https://img.youtube.com/vi/${url.split("/")[4]}/0.jpg`,
  }));
  const handlePreviosVideoClick = () => {
    if (activeVideo) {
      const currentVideoIndex = tvAds.indexOf(activeVideo);
      if (currentVideoIndex === 0) {
        setActiveVideo(tvAds[tvAds.length - 1]);
      } else {
        setActiveVideo(tvAds[currentVideoIndex - 1]);
      }
      leftButtonRef.current.click();
    }
  };
  const handleNextVideoClick = () => {
    if (activeVideo) {
      const currentVideoIndex = tvAds.indexOf(activeVideo);
      if (currentVideoIndex === tvAds.length - 1) {
        setActiveVideo(tvAds[0]);
      } else {
        setActiveVideo(tvAds[currentVideoIndex + 1]);
      }
      rightButtonRef.current.click();
    }
  };

  return (
    <Layout pageTitle="Videos" backButton={true}>
      <Banner
        backgroundImage={
          currentPage && currentPage.image
            ? "https://res.cloudinary.com/dygwe02oe/image/upload/v1589540221/samples/media_lygdpq.png"
            : ""
        }
        title="Videos"
      />

      {!isMobile ? (
        <div className={styles["fullscreen-carousel"]}>
          <>
            {loading ? <Loader /> : null}
            {activeVideo ? (
              <YouTube
                videoId={activeVideo.url.split("/")[4]}
                opts={youtubeFrameOpts}
                onReady={onVideoReady}
              />
            ) : null}
            <div>
              <ArrowButton
                onClick={handlePreviosVideoClick}
                color={["white"]}
                arrowDirection="left"
              />
              <ArrowButton onClick={handleNextVideoClick} color={["blue"]} arrowDirection="right" />
            </div>
          </>
        </div>
      ) : null}
      <div>
        {previews && previews.length ? (
          <Carousel
            carouselType="videos"
            slides={previews}
            leftButtonRef={leftButtonRef}
            rightButtonRef={rightButtonRef}
            render={(slides, activeSlide) =>
              slides.map(({ url, name }, index) => (
                <div key={url} onClick={setActiveVideoId({ url, name })}>
                  <ViewPreview
                    url={url}
                    name={name}
                    activeVideo={activeVideo.name === name}
                    activePost={activeSlide === index}
                    setPlaylist={setPlaylist}
                    playlist={playlist}
                    isSmall
                  />
                </div>
              ))
            }
          />
        ) : null}
      </div>
    </Layout>
  );
};

export default MediaReleasesAds;
